// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__f48I8","content":"styles_content__DJ65t","footer":"styles_footer__olKxL"};